import React, { useState } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Swal from 'sweetalert2';

import WppButton from 'src/components/functional/WppButton';

import { suitcaseMontageData } from 'src/data/suitcaseMontageData';
import FooterCheckout from 'src/components/functional/FooterCheckout';
import CheckoutHeader from 'src/components/functional/HeaderCheckout';
import ChoosePaymentMethod from './Components/ChoosePaymentMethod';
import PurchaseResume from './Components/PurchaseResume';
import PurchaseForms from './Components/PurchaseForms';

import { ICustomerData } from '../../interfaces';
import { apiCheckout } from '../../api';

import { CheckoutComponent, ContainerCheckout, ContainerContent } from './style';

import loadingGIF from '../../../../assets/gifs/loading.png';

export default function CheckoutSuitcaseMontage(): JSX.Element {
  const [customerData, setCustomerData] = useState<ICustomerData>();
  const [component, setComponent] = useState(0);

  const { token, platform, serviceName } = useParams();

  const serviceData = suitcaseMontageData.find(
    (item) => item.serviceName === serviceName.replaceAll('-', ' ')
  );

  const { isLoading, isError } = useQuery(
    ['getUserInfo', token],
    async () => apiCheckout.getUserProfileInfo(token),
    {
      onError: () => {
        void Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro ao recuperar os dados!',
          text: 'Por favor, tente novamente mais tarde, ou contate a central.',
          iconColor: 'black',
          confirmButtonColor: 'black',
        });
      },
      onSuccess: (data) => {
        setCustomerData({
          customerName: `${data.firstName} ${data.lastName}`,
          customerEmail: data.email,
          zipCode: data.zipCode,
          customerCpf: '',
          street: '',
          neighborhood: '',
          city: data.city,
          state: data.state,
          streetNumber: '',
          customerPhone: data.phone,
          consultantId: data.consultantId,
          consultantName: data.consultantName,
          recipientId: data.recipientId,
          splitPercentage: data.splitPercentage,
        });
      },
      refetchOnWindowFocus: false,
    }
  );

  const renderComponent = (): JSX.Element => {
    if (component === 0) {
      return (
        <PurchaseForms
          customerData={customerData}
          setCustomerData={setCustomerData}
          setComponent={setComponent}
        />
      );
    }
    return (
      <ChoosePaymentMethod
        customerData={customerData}
        serviceData={serviceData}
        setComponent={setComponent}
        platform={platform}
      />
    );
  };

  return (
    <ContainerCheckout>
      <CheckoutHeader />
      <ContainerContent>
        <PurchaseResume serviceData={serviceData} />
        {isLoading || isError ? (
          <img src={loadingGIF} alt="Loading spinning" width="100" height="100" />
        ) : (
          <CheckoutComponent>{renderComponent()}</CheckoutComponent>
        )}
      </ContainerContent>
      <WppButton />
      <FooterCheckout />
    </ContainerCheckout>
  );
}
